import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { useListingClinicsByAreaQuery } from '../../../generated/queries';
import { isDefined } from '../../commons/is-defined';

export function mapClinicsByArea(
  input: ParagraphListingClinicsByAreaFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'LinkList'> {
  return {
    key: 'LinkList',
    input: function useListingClinicsByArea() {
      const { data, isLoading, isFetching } = useListingClinicsByAreaQuery({
        argument: input.argument || '',
        offset: 0,
        limit: 99999,
      });
      return [
        {
          title: input.title,
          items: data?.listingClinicsByArea.items
            .filter(isDefined)
            .map((item) => ({
              Link: buildLink({ href: item.path }),
              title: item.title,
            })),
        },
        isLoading || isFetching
          ? 102
          : data
          ? data.listingClinicsByArea.items.length > 0
            ? 200
            : 404
          : 0,
      ];
    },
  };
}
